import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    setModal,
    addToTransfer,
} from '../../../redux/actions/stock_transfer/stock_transfer.actions';
import { numberFormat } from '../../../Utils/Common';
import { MiniSpinner } from '../../layouts/Spinner';

function ItemModal({ stock_transfer, setModal, addToTransfer, transferType }) {
    const handleSelect = (item) => {
        // In OUT mode, block out-of-stock items; IN mode allows them
        if (!item.inStock && transferType !== 'in') return;

        addToTransfer(item);
        setModal('transfer_item_modal', false);
    };

    return (
        <Modal
            centered
            dialogClassName="modal-container"
            show={stock_transfer.transfer_item_modal}
            onHide={() => setModal('transfer_item_modal', false)}
            size="md"
            animation={true}
        >
            <Modal.Header closeButton>
                <Modal.Title>Select Product</Modal.Title>
            </Modal.Header>
            <Modal.Body className="mt-0 pt-0">
                <div className="row f-regular">
                    <div className="col-12">
                        {stock_transfer.pos_loading === 'item-modal' ? (
                            <div className="col-12">
                                <div className="my-5">
                                    <MiniSpinner />
                                </div>
                            </div>
                        ) : (
                            stock_transfer.products.map((item, index) => {
                                const blocked =
                                    !item.inStock && transferType !== 'in';
                                return (
                                    <div
                                        key={index}
                                        onClick={() => handleSelect(item)}
                                        className={`card card-body pos-card-list shadow mb-1 bg-white rounded ${
                                            blocked
                                                ? 'bg-danger bg-accent-2'
                                                : item.stockWarning
                                                ? 'bg-warning bg-accent-2'
                                                : ''
                                        }`}
                                        style={{
                                            cursor: blocked
                                                ? 'not-allowed'
                                                : 'pointer',
                                            opacity: blocked ? 0.7 : 1,
                                        }}
                                    >
                                        <div className="row">
                                            <div className="col-2">
                                                <img
                                                    src={item.product_image}
                                                    className="img img-thumbnail"
                                                    alt={item.product_name}
                                                />
                                            </div>
                                            <div className="col-6">
                                                {item.product_name}
                                                <div>
                                                    <small>
                                                        SKU: {item.sku}
                                                    </small>
                                                </div>
                                                <div>
                                                    <small>
                                                        Barcode: {item.barcode}
                                                    </small>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="float-right">
                                                    <small>
                                                        SRP:{' '}
                                                        <span className="pos-strong-text">
                                                            {numberFormat(
                                                                item.srp
                                                            )}
                                                        </span>
                                                    </small>
                                                    <div>
                                                        {item.stockWarning && (
                                                            <span className="lbl-status lbl-pos-warning">
                                                                LOW THRESHOLD
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {!item.inStock && (
                                                            <span className="lbl-status lbl-danger">
                                                                OUT OF STOCK
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

const mapStateToProps = (state) => ({
    stock_transfer: state.stock_transfer,
});

export default connect(mapStateToProps, {
    setModal,
    addToTransfer,
})(ItemModal);
